import { createContext, useContext } from "react";

export interface OnboardingLayoutContextValue {
  setHideAlternateAction: (hide: boolean) => void;
}

export const OnboardingLayoutContext =
  createContext<OnboardingLayoutContextValue>({
    setHideAlternateAction: () => {},
  });

export const useOnboardingLayout = (): OnboardingLayoutContextValue =>
  useContext(OnboardingLayoutContext);
